// extracted by mini-css-extract-plugin
export default {"section":"worktime_section__qJrIm","sectionHeading":"worktime_sectionHeading__L9vxA","table":"worktime_table__BAI+0"};